import React from "react";
import { Form, Checkbox } from "semantic-ui-react";
import PropTypes from "prop-types";

/**
 * Email recipient selector component
 */
const EmailRecipientSelector = ({
  recipients,
  value,
  onChange,
  forEntity = false,
  showAlternativeEmailsToggle = false,
  includeAlternativeEmails = false,
  onToggleAlternativeEmails,
}) => {
  if (forEntity) {
    return null;
  }

  return (
    <>
      <Form.Select
        selectOnBlur={false}
        required
        label="Recipients"
        clearable
        multiple
        search
        onChange={onChange}
        options={recipients}
        value={value}
        placeholder="Select an email address"
      />
      {showAlternativeEmailsToggle && (
        <Form.Field inline>
          <label onClick={onToggleAlternativeEmails}>
            Include Alternative Emails
          </label>
          <Checkbox
            toggle
            checked={includeAlternativeEmails}
            onChange={onToggleAlternativeEmails}
          />
        </Form.Field>
      )}
    </>
  );
};

EmailRecipientSelector.propTypes = {
  recipients: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  forEntity: PropTypes.bool,
  showAlternativeEmailsToggle: PropTypes.bool,
  includeAlternativeEmails: PropTypes.bool,
  onToggleAlternativeEmails: PropTypes.func,
};

export default EmailRecipientSelector;
